﻿$.fn.dxCtrlPopupBase = function custom_dxCtrlPopupBase(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpopupbase dx-ctrl");
        this.createInstance(new cdxCtrlPopupBase(this, option));
    }
    return this;
}

//window.setVH = null
//$(document).ready(function () {
//    if (parametre.isMobile) {
//        //gestion des dxpopup sur mobile
//        window.setVH = function () {
//            const vv = window.visualViewport;
//            const h = vv ? vv.height : window.innerHeight;
//            document.documentElement.style.setProperty('--vhpx', h + 'px');
//        }
//        setVH();
//        if (window.visualViewport) {
//            visualViewport.addEventListener('resize', setVH);
//            visualViewport.addEventListener('scroll', setVH);
//        }
//        window.addEventListener('orientationchange', setVH);
//        window.addEventListener('resize', setVH);
//    }
//})

window.indexPopupGeneral = 0
window.cdxCtrlPopupBase = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;
    if (typeof option.shading == 'undefined') option.shading = true;
    if (typeof option.width == 'undefined') option.width = "100%";
    if (typeof option.height == 'undefined') option.height = "100%";
    if (typeof option.showCloseButton == 'undefined') option.showCloseButton = true;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return dx.option(name);
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var dx = null;
    this.jauge = null;
    this.titleElementBase = null;
    this.titleElementIcone = null
    this.titleElementLib = null;
    this.contentElement = null;
    var funcResize = null;
    this.inReduce = false;
    this.dxBtClose = null;
    var isFullScreen = false;
    indexPopupGeneral += 1
    var indexPopupInterne = indexPopupGeneral

    //var $DivContentMobile = null
    //var $DivTitleMobile = null
    container.addClass("popupnormal" + indexPopupInterne)
    function mConstruit() {
        container.empty();

        //if (option.isFullScreen && parametre.isMobile) {
        //    $DivContentMobile = $("<div style='position:absolute;width:100%;height:100%;'/>").appendTo("body")
        //    if (option.showTitle) {
        //        $DivTitleMobile = $("<div style='height:56px;'/>").appendTo($DivContentMobile)
        //        $DivContentInnerMobile = $("<div style='height:calc(100% - 56px)'/>")
        //    } else {
        //        $DivContentInnerMobile = $("<div style='height:100%'/>")
        //    }
        //}

        isFullScreen = ((typeof option.fullScreen != 'undefined' && option.fullScreen != null & option.fullScreen) ? true : false)

        if (typeof option.dragEnabled == "undefined") option.dragEnabled = false
        this.$TdReduce = null;
        this.$TdClose = null;
        var titleTemplate = option.titleTemplate;
        option.titleTemplate = function (titleElement) {
            titleElement.attr("idpopup", "popupnormal" + indexPopupInterne)
            titleElement.css("border", "none")
            Me.titleElementBase = titleElement;
            titleElement.css("padding", "0");
            titleElement.css("height", HeightEntete + "px");
            //titleElement.css("border-bottom", theme.border);
            var $Table = $("<table style='height:" + HeightEntete + "px;width:100%;table-layout:fixed;'/>").appendTo(titleElement);
            var $Tr = $("<tr/>").appendTo($Table);
            if (typeof option.titleIconeTemplate != 'undefined') {
                Me.titleElementIcone = $("<td style='overflow-y:hidden;text-align:left;overflow-x:hidden;text-overflow:ellipsis;font-size:22px;width:60px;' class='tdiconetitle'/>").appendTo($Tr);
                option.titleIconeTemplate(Me.titleElementIcone)
            }
            var $TdLib = $("<td style='overflow:hidden;text-align:left;text-overflow:ellipsis;width:100%;font-size:22px;white-space:nowrap;' class='tdlibtitle'/>").appendTo($Tr);
            if (typeof option.title != 'undefined') {
                $("<span>" + option.title + "</span>").appendTo($TdLib);
                $TdLib.css("padding-left", "10px")
            }
            Me.titleElementLib = $TdLib;
            Me.$TdCmd = $("<td style='width:0px;' class='tdCommand'/>")
            if (typeof option.tdTitleTemplate != 'undefined') {
                Me.$TdTemplate = $("<td style='width:0px;' class='tdTemplate'/>").appendTo($Tr)
                option.tdTitleTemplate(Me.$TdTemplate)
            }
            //var widthTdCmd = 0
            if (typeof option.showTitle == 'undefined' || option.showTitle) {
                //var $TableCmd = $("<table style='height:" + HeightEntete + "px;'/>").appendTo(Me.$TdCmd);
                //var $Tr = $("<tr/>").appendTo($TableCmd);
                if (typeof option.onTitleCmdTemplate != 'undefined') {
                    var $TdTitleCmdTemplate = $("<td style='width:110px'/>").appendTo($Tr);
                    option.onTitleCmdTemplate($TdTitleCmdTemplate, Me);
                }
                if (typeof option.buttons != 'undefined') {
                    option.buttons.forEach(function (bt) {
                        var $Td = $("<td style='width:" + (HeightButton - 2) + "px'/>").appendTo($Tr);
                        var bt = $("<div class=''/>").appendTo($Td).dxCtrlButton({
                            focusStateEnabled: false,
                            height: HeightButton - 2,
                            width: HeightButton - 2,
                            icon: bt.icon,
                            txtTooltip: bt.txtTooltip,
                            onClick: bt.onClick,
                            onContentReady: bt.onContentReady
                        }).dxCtrlButton("instance");
                        bt.instance = bt
                    })
                }
                if (typeof option.onDelete != 'undefined') {
                    var $TdDelete = $("<td style='width:" + (HeightButton - 2) + "px'/>").appendTo($Tr);
                    var bt = $("<div class=''/>").appendTo($TdDelete).dxCtrlButton({
                        focusStateEnabled: false,
                        height: HeightButton - 2,
                        width: HeightButton - 2,
                        icon: 'fas fa-trash-alt',
                        onClick: function (e) {
                            var result = option.onDelete($TdDelete, Me)
                            if (typeof result == 'undefined' || result) dx.hide();
                        }
                    }).dxCtrlButton("instance");
                }

                //var $Td = $("<td style=''/>").appendTo($Tr);
                ////var $Td = $("<td style='width:1px;" + ((typeof option.titleEmpty == 'undefined' || !option.titleEmpty) ? "border-left:" + theme.border + ";" : "") + "'/>").appendTo($Tr);
                //var $Table = $("<table style='height:" + HeightEntete + "px;'/>").appendTo($Td);
                //var $Tr = $("<tr/>").appendTo($Table);
                if (typeof option.showMaximize == 'undefined' || option.showMaximize) {
                    Me.$TdFulleScreen = $("<td style='width:" + (HeightButton - 2) + "px'/>").appendTo($Tr);
                    var bt = $("<div class=''/>").appendTo(Me.$TdFulleScreen).dxCtrlButton({
                        focusStateEnabled: false,
                        height: HeightButton - 2,
                        width: HeightButton - 2,
                        icon: 'fas fa-window-maximize',
                        txtTooltip: "Agrandir",
                        onClick: function (e) {
                            isFullScreen = !isFullScreen
                            $(window).trigger('resize');
                        }
                    }).dxCtrlButton("instance");
                    if (!option.shading && (typeof option.showMinimize == 'undefined' || option.showMinimize)) {
                        Me.$TdReduce = $("<td style='width:" + (HeightButton - 2) + "px'/>").appendTo($Tr);
                        var bt = $("<div/>").appendTo(Me.$TdReduce).dxCtrlButton({
                            focusStateEnabled: false,
                            height: HeightButton - 2,
                            width: HeightButton - 2,
                            icon: 'fas fa-window-minimize',
                            txtTooltip: "Réduire",
                            onClick: function (e) { Me.inReduce = true; dx.hide() }
                        }).dxCtrlButton("instance");
                    }
                }
                if (option.showCloseButton) {
                    Me.$TdClose = $("<td style='width:" + (HeightButton - 2) + "px'/>").appendTo($Tr);
                    Me.dxBtClose = $("<div class='dxbtclose'/>").appendTo(Me.$TdClose).dxCtrlButton({
                        icon: 'fas fa-times',
                        width: HeightButton - 2,
                        height: HeightButton - 2,
                        onClick: function (e) {
                            if (typeof option.onClickClose == 'undefined') { dx.hide() }
                            else {
                                if (option.onClickClose(Me.dxBtClose.element(), function () { dx.hide() })) { dx.hide(); }
                            }
                        }
                    }).dxCtrlButton("instance");
                }
            }
            if (typeof titleTemplate != 'undefined' && typeof option.title == 'undefined') titleTemplate($TdLib);
        }
        var contentTemplate = option.contentTemplate;
        var widthBase = null
        var widthSave = null
        if (option.fullScreen) widthBase = option.width
        option.contentTemplate = function (contentElement) {
            contentElement.attr("idpopup", "popupnormal" + indexPopupInterne)
            if (widthBase != null) { option.width = widthBase; widthSave = widthBase; widthBase == null; }
            //Me.contentElement = contentElement;
            //if (typeof contentTemplate != 'undefined') contentTemplate(contentElement);
            Me.contentElement = contentElement;
            Me.$DivContent = $("<div style='width:100%;height:100%;opacity:0;'/>").appendTo(contentElement)
            Me.$DivContent.css("padding", contentElement.css("padding"))
            Me.contentElement.css("padding", "0");
            Me.contentElement.css("overflow", "hidden");
            if (typeof contentTemplate != 'undefined') contentTemplate(Me.$DivContent);
        }
        var onhiding = option.onHiding
        var isInHiding = false
        option.onHiding = function (e) {
            if (isInHiding) {
                if (typeof option.onStartHidden != 'undefined') option.onStartHidden()
                return;
            }
            isInHiding = true;
            if (typeof onhiding != 'undefined') onhiding(e);
            if (!e.cancel) {
                if (!Me.inReduce) {
                    e.cancel = true
                    window.setTimeout(function () {
                        Me.destroy()
                        isInHiding = false;
                    }, 0);
                } else {
                    if (typeof option.onReduce != 'undefined') option.onReduce()
                    isInHiding = false;
                }
            } else {
                if (typeof option.onStartHidden != 'undefined') option.onStartHidden()
                isInHiding = false;
            }
        }
        var onHidden = option.onHidden;
        option.onHidden = function (e) {
            if (!Me.inReduce) {
                if (funcResize) lstEventResize.splice(lstEventResize.indexOf(funcResize), 1);
                e.component.element().remove();
                if (typeof option.onDestroy != 'undefined') option.onDestroy();
                if (typeof onHidden != 'undefined') onHidden(e);
            }
            Me.inReduce = false;
        }


        var maxZindex = mGetMaxZindex() + 1
        var onContentReady = option.onContentReady;
        option.onContentReady = function (e) {
            //le zindex est pas toujours bon, on le réécrit
            if (e.component.$wrapper()[0].style.zIndex < maxZindex) e.component.$wrapper()[0].style.zIndex = maxZindex;
            if (typeof option.hasJauge != 'undefined' && option.hasJauge) {
                Me.jauge = $("<div/>").appendTo(Me.contentElement).dxCtrlJauge({ opacity: 1 }).dxCtrlJauge("instance");
                Me.jauge.mShow();
            }
            if (typeof onContentReady != 'undefined') onContentReady(e);
            if (funcResize) funcResize()
        }

        option.isFullScreen = option.fullScreen
        var widthPercent = 0;

        if ((typeof option.width != 'undefined' && option.width != null && option.width.toString().contains("%")) || option.fullScreen) {
            if (option.fullScreen) { widthPercent = 1 }
            else if (option.width.toString().contains("%")) widthPercent = parseInt(option.width.toString().replace("%")) / 100
            if (option.fullScreen) {
                option.width = $(window).innerWidth();
                option.fullScreen = false;
            }
        }
        var onshown = option.onShown
        option.onShown = function (e) {
            Me.$DivContent.animate({ opacity: 1 }, 500, function () {
                window.setTimeout(function () {
                    var compoFocus = Me.$DivContent.find(".dxctrlfocus")
                    if (compoFocus.length > 0) {
                        if (typeof compoFocus.getInstance != 'undefined' && compoFocus.getInstance() != null) { compoFocus.getInstance().focus(); }
                        else { compoFocus.find(".dx-texteditor-input").focus() }
                    }
                }, 0)
            });
            if (typeof onshown != 'undefined') onshown(e);
        }
        //var heightPercent = 0;
        //if ((typeof option.height != 'undefined' && option.height.toString().contains("%")) || option.fullScreen) {
        //    if (option.fullScreen) { heightPercent = 1 }
        //    else if (option.height.toString().contains("%")) heightPercent = parseInt(option.height.toString().replace("%")) / 100
        //    if (option.fullScreen) {
        //        option.height = $(window).innerHeight();
        //        option.fullScreen = false;
        //    }
        //}
        if (option.fullScreen) option.fullScreen = false;
        funcResize = lstEventResize.push(function () {
            if (dx != null) {
                if (!isFullScreen) {
                    if (widthSave != null) {
                        var newWidth = widthSave;
                        if (typeof option.minWidth > newWidth) newWidth = $(window).innerWidth()
                        dx.option("width", newWidth);

                    } else if (widthPercent != 0) {
                        var newWidth = $(window).innerWidth() * widthPercent;
                        if (typeof option.minWidth > newWidth) newWidth = $(window).innerWidth()
                        dx.option("width", newWidth);
                    }
                    else {
                        if (typeof option.width != "undefined") {
                            if (option.width > $(window).innerWidth()) { dx.option("width", $(window).innerWidth()); }
                            else { dx.option("width", option.width); }
                        }
                    }
                    //if (heightPercent != 0) { dx.option("height", $(window).innerHeight() * heightPercent); }
                    //else {
                    //    if (typeof option.height != "undefined") {
                    //        //if (option.height > $(window).innerHeight()) { dx.option("height", $(window).innerHeight()); }
                    //        //else { dx.option("height", option.height); }
                    //        dx.option("height", option.height);
                    //    }
                    //}
                }
                else { dx.option("width", $(window).innerWidth()); }
            }
            if (typeof option.onResize != 'undefined') option.onResize()
        });
        funcResize = lstEventResize[funcResize - 1]
        //}
        //var maxZindex = mGetMaxZindex()
        console.log("DevExpress.ui.dxOverlay.baseZIndex()=" + DevExpress.ui.dxOverlay.baseZIndex())
        //option.wrapperAttr= {
        //    style: "z-index:" + (mGetMaxZindex()+1)
        //}

        if (parametre.isMobile) {
            if (!option.isFullScreen) {
                option.position = {
                    my: "center top",
                    at: "center top",
                    of: window,
                    offset: "0 50" // ou { x: 0, y: 50 }
                }
            }
            option.animation = null
            option.deferRendering = false
        }

        dx = container.dxPopup(option).dxPopup("instance")

        dx.pop = Me;

    }

    function isConfiguredFullHeight(popup) {
        const h = popup.option("height");
        return popup.option("fullScreen") === true
            || h === "100%"
            || h === "100vh";
    }

    this.component = function () { return dx; }
    this.show = function () {
        dx.show();
        if (typeof option.onShow != 'undefined') option.onShow()
    }
    this.hide = function () {
        this.inReduce = false
        dx.hide();
    }
    this.reduce = function () {
        this.inReduce = true
        dx.hide();
    }
    this.destroy = function () {
        this.inReduce = false;
        if (this.option("visible")) { dx.hide(); }
        else {
            this.element().remove()
            if (typeof option.onDestroy != 'undefined') option.onDestroy();
        }
    }
    this.mDestroy = function () { this.destroy() }
    this.bringToFront = function () {
        dx._updateZIndexStackPosition(false);
        dx._updateZIndexStackPosition(true);
    }
    this.mGetZindex = function () {
        return parseInt($(Me.contentElement.closest(".dx-overlay-content")[0]).css("z-index"))
    }

    this.element = function () { return container; }

    this.elementOverlayWrapper = function () {
        return $(Me.contentElement.closest(".dx-overlay-wrapper")[0])
    }
    this.elementOverlayContent = function () {
        return $(Me.contentElement.closest(".dx-overlay-content")[0])
    }

    mConstruit();
}

window.mShowPopup2Bouton = function (title, text, textBt1, textBt2, funcBt1, funcBt2) {
    var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
        title: title,
        fullScreen: false,
        width: 400,
        height: "auto",
        showMaximize: false,
        contentTemplate: function (contentElement) {
            $("<div style=''/>" + text + "</div>").appendTo(contentElement);
            $("<div style='padding-top:10px'/>").appendTo(contentElement);
            var $Table = $("<table/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table);
            $("<td style='width:100%'/>").appendTo($Tr)
            var $Td = $("<td style='width:1px;padding-right:5px'/>").appendTo($Tr)
            var btOk = $("<div/>").appendTo($Td).dxCtrlButton({
                text: textBt1,
                focusStateEnabled: false,
                onClick: function (e) { funcBt1(pop) }
            }).dxCtrlButton("instance");
            var $Td = $("<td style='width:1px;padding-right:5px'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                text: textBt2,
                focusStateEnabled: false,
                onClick: function (e) { funcBt2(pop); }
            });
        }
    }).dxCtrlPopupBase("instance")
    pop.show();
}